import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=72d00a92&"
import script from "./AccountSetting.vue?vue&type=script&lang=ts&"
export * from "./AccountSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports